export const APP_LOCAL_STORAGE_PREFIX = 'traffic-laws'
const STORAGE_VERSION = 'v1'
export const useLocalStorageKey = () => {
  return (key: string) => {
    return `${APP_LOCAL_STORAGE_PREFIX}_${STORAGE_VERSION}_${key}`
  }
}
